import { Box, Divider, Stack, Typography } from "@mui/material";
import React from "react";

interface SectionHeaderProps {
  title: string;
  icon: React.ReactNode;
  divider?: boolean;
}

const SectionHeader = ({ title, icon, divider = true }: SectionHeaderProps) => {
  return (
    <Stack spacing={2}>
      <Stack direction="row" alignItems="center" spacing={1.5}>
        <Box
          sx={{
            width: 40,
            height: 40,
            borderRadius: "50%",
            bgcolor: "#FFF3EC",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",

            "& svg": {
              width: 20,
              height: 20,
            },
          }}
        >
          {icon}
        </Box>

        <Typography
          variant="h5"
          sx={{
            fontWeight: 700,
            fontSize: 20,
            color: "text.primary",
          }}
        >
          {title}
        </Typography>
      </Stack>

      {divider && <Divider />}
    </Stack>
  );
};

export default SectionHeader;
